__turbopack_context__.v({
  "content": "BoutiquesFindCta-module-scss-module__AsaXka__content",
  "cta": "BoutiquesFindCta-module-scss-module__AsaXka__cta",
  "description": "BoutiquesFindCta-module-scss-module__AsaXka__description",
  "image": "BoutiquesFindCta-module-scss-module__AsaXka__image",
  "media": "BoutiquesFindCta-module-scss-module__AsaXka__media",
  "panel": "BoutiquesFindCta-module-scss-module__AsaXka__panel",
  "section": "BoutiquesFindCta-module-scss-module__AsaXka__section",
  "visuallyHidden": "BoutiquesFindCta-module-scss-module__AsaXka__visuallyHidden",
});
